// Identificação da build, injetada em build time pelo deploy (assim como a URL
// da API — o Create React App resolve REACT_APP_* durante o `npm run build`,
// então não adianta definir isso no ambiente do container).
//
// Em desenvolvimento as variáveis não existem e os valores caem no padrão
// "desenvolvimento", deixando claro que não é uma build publicada.

export const BUILD_VERSAO = process.env.REACT_APP_BUILD_VERSION || 'desenvolvimento';

// ISO 8601 em UTC, gerado no momento do build.
export const BUILD_DATA_ISO = process.env.REACT_APP_BUILD_TIME || null;

export const EH_BUILD_PUBLICADA = Boolean(process.env.REACT_APP_BUILD_VERSION);

/**
 * Data/hora da build no fuso de Brasília, no formato dd/mm/aaaa hh:mm.
 * Retorna null quando não é uma build publicada.
 */
export function formatarDataBuild() {
    if (!BUILD_DATA_ISO) return null;

    const data = new Date(BUILD_DATA_ISO);
    if (Number.isNaN(data.getTime())) return null;

    return new Intl.DateTimeFormat('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(data);
}
